import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentService } from '../../services/content/content.service';

@Pipe({
  name: 'contentGastro'
})
export class GastroPipe implements PipeTransform {

  lunchStartTime;
  lunchEndTime;
  dinnerStartTime;
  dinnerEndTime;
  separator;
  disclaimer;

  constructor(private contentService: ContentService) {
  }

  transform(entry: Models.ContentEntry, parent = null): Models.GastroEntry | Models.GastroEntry[] {
    if (!entry) {
      return null;
    }

    if (entry.related && entry.related.entries && entry.related.entries.length > 0 && !entry.detail.forcePipe) {
      if (entry.detail.lunchStartTime) {
        this.lunchStartTime = entry.detail.lunchStartTime;
      }
      if (entry.detail.lunchEndTime) {
        this.lunchEndTime = entry.detail.lunchEndTime;
      }
      if (entry.detail.dinnerStartTime) {
        this.dinnerStartTime = entry.detail.dinnerStartTime;
      }
      if (entry.detail.dinnerEndTime) {
        this.dinnerEndTime = entry.detail.dinnerEndTime;
      }
      if (entry.detail.separator) {
        this.separator = entry.detail.separator;
      }
      if (entry.detail.disclaimer) {
        this.disclaimer = entry.detail.disclaimer;
      } else if (!!entry.related.entries.find(e => !!this.contentService.getEntry(e.id)?.detail?.disclaimer?.length)) {
        const id = entry.related.entries.find(e => !!this.contentService.getEntry(e.id)?.detail?.disclaimer?.length).id;
        this.disclaimer = this.contentService.getEntry(id).detail.disclaimer;
      }
      const entries: Models.GastroEntry[] = [];

      for (const item of entry.related.entries) {
        const contentEntry = this.contentService.getEntry(item.id);
        const transformed = this.transform(contentEntry, entry) as Models.GastroEntry;
        if (transformed) {
          entries.push(transformed);
        }
      }
      return entries.length === 0 ? null : entries;
    }

    if (!entry.detail) {
      return null;
    }

    if (!this.contentService.isValid(entry)) {
      return null;
    }

    const gastro = new Models.GastroEntry();
    gastro.populateFromJSON({
      sourceId: entry._id,
      date: entry.detail.date,
      lunch: entry.detail.lunch,
      dinner: entry.detail.dinner,
      hits: entry.detail.hits,
      separator: this.separator,
      disclaimer: this.disclaimer,
      lunchStartTime: this.lunchStartTime,
      lunchEndTime: this.lunchEndTime,
      dinnerStartTime: this.dinnerStartTime,
      dinnerEndTime: this.dinnerEndTime
    });

    return gastro;
  }

}
